/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-09-14                                                        *
 ******************************************************************************/

import no_spinner_axios from '../../utils/no-spinner-axios';

const QuotePublishingStore = {
    namespaced: true,
    state: {
        publishing:{}
    },
    mutations: {
        storePublishing(state,publishingObject){
            state.publishing = publishingObject;
        }
    },
    actions: {
        show(context,params={}){
            return new Promise(callAxios);

            function callAxios(resolve, reject) {
                no_spinner_axios
                    .get('/v2/quote_publishing', {
                        params: params
                    })
                    .then(success)
                    .catch(failure);

                function success(response) {
                    resolve(response.data);
                    context.commit('storePublishing',response.data);
                }
                function failure(error) {
                    console.log(error);
                    reject(error);
                }
            }
        },
        create(context, item) {
            return new Promise(callAxios);

            function callAxios(resolve, reject) {
                no_spinner_axios
                    .post('/v2/quote_publishing', item)
                    .then(success)
                    .catch(failure);

                function success(response) {
                    resolve(response.data);
                    context.commit('storePublishing',response.data);
                }

                function failure(error) {
                    console.log(error.response ? error.response.data : error);
                    reject(error);
                }
            }
        }
    }
};
export default QuotePublishingStore;
